import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { ClinicianDetailsWithId } from "../types/user";
import * as apiClient from "../api";
import { LinearProgress } from "@mui/material";

const CLINICIAN_ID = "d56d76be-3411-43a1-9ca4-1a3468d3ef84";

const defaultClinician = {
  clinicianId: "",
  firstName: "",
  lastName: "",
  email: "",
};

const ClinicianContext = createContext<
  [ClinicianDetailsWithId, Dispatch<SetStateAction<ClinicianDetailsWithId>>]
>([defaultClinician, () => {}]);

export const useClinicianContext = () => useContext(ClinicianContext);

export const ClinicianProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [clinician, setClinician] = useState(defaultClinician);

  useEffect(() => {
    const loadClinician = async () => {
      const result = await apiClient.getClinician(CLINICIAN_ID);
      setClinician({ clinicianId: CLINICIAN_ID, ...result.data });
      setLoaded(true);
    };
    loadClinician();
  }, []);

  return (
    <ClinicianContext.Provider value={[clinician, setClinician]}>
      {loaded ? children : <LinearProgress />}
    </ClinicianContext.Provider>
  );
};
